export default "__VITE_ASSET__9EEptD7Y__"